let sitesInfo = {
  wwwHiworks : process.env.VUE_APP_HIWORKS_COM,
  goodsApi: process.env.VUE_APP_GOODS_API,
}

const mountEl = document.querySelector('#step1-app');

/**
 * 사용할 url이 attribute로 유효하게 넘어왔는지에 대한 체크
 *
 * @param attributeName 파싱할 attributeName
 * @returns {boolean}
 */
let checkIsValidDomainAttribute = function (attributeName){
  const regex = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/
  if(!mountEl.attributes[attributeName]){
    return false
  }
  if(!mountEl.attributes[attributeName].value){
    return false
  }
  if(!regex.test(mountEl.attributes[attributeName].value)){
    return false
  }

  return true
}

sitesInfo.wwwHiworks = checkIsValidDomainAttribute('data-www-hiworks')
    ? mountEl.attributes['data-www-hiworks'].value
    :  sitesInfo.wwwHiworks

sitesInfo.goodsApi = checkIsValidDomainAttribute('data-goods-api')
    ? mountEl.attributes['data-goods-api'].value
    : sitesInfo.goodsApi

export default sitesInfo